import { css } from "@emotion/react";

export const printAndScreen = (whenScreen: any, whenPrint: any) => css({
    '@media print': whenPrint,
    '@media screen': whenScreen
})